

export default {
    // @Partner
    setNewCreatedPartner(state, value){
        state.newCreatedPartner = value
    },
}